type ChannelLike = { service?: string | null }

/** Whether a single channel is a Google Business Profile. */
export const isGoogleBusinessChannel = (channel: ChannelLike): boolean =>
  channel.service === 'googlebusiness'

/** Whether any channel in the list is a Google Business Profile. */
export const isGoogleBusinessProfile = (
  channels: ChannelLike[] | undefined,
): boolean => channels?.some(isGoogleBusinessChannel) ?? false

/**
 * Service name for inline prose beside a channel icon. Shorter than
 * `getChannelName`, which spells out the full product name ("Twitter / X",
 * "Google Business Profile") and reads as a mouthful mid-sentence.
 */
export const getDisplayServiceName = (service: string): string => {
  if (service === 'googlebusiness') {
    return 'Google Business'
  }
  return service.charAt(0).toUpperCase() + service.slice(1)
}
